/**
 * 全局loading组件
 * @author haoru
 */
import React from 'react';
import { RootState, useRematchState } from '@/pure-store';
import Loading from '@/components/Loading';

const mapState = (state: RootState) => ({
  globalLoading: state.common.loading
});

const GlobalLoading = () => {
  const { globalLoading } = useRematchState(mapState);

  console.log('GlobalLoading', globalLoading);

  return <>{globalLoading ? <Loading /> : ''}</>;
};

export default GlobalLoading;
